// extracted by extract-css-chunks-webpack-plugin
module.exports = {"body":"body___QcRoV","container":"container___Bg_pF","button":"button___kMJVx","header":"header___WehKW","size":"size___jvQmW"};